<template>
    <div class="pa-0 container">
        <v-row style="height: 100%">
            <v-col class="text-center d-inline-flex justify-center align-center" cols="12">
                <v-card >
                    <v-card-text>
                        <h2 class="primary--text pt-6 pb-3 pa-0">Recuperar contraseña</h2>
                        <v-subheader class="text-center d-none d-md-block">Ingrese su cuenta para recibir un correo de recuperación de contraseña</v-subheader>
                        <form class="">
                            <v-text-field
                                v-model="email"
                                label="Correo"
                                append-icon="mdi-email"
                                type="email"
                                :rules="[rules.required, rules.valid, user_exists]"
                                outlined
                                class="pb-3"
                            ></v-text-field>
                            <v-btn 
                                color="accent" 
                                @click="sendEmail" 
                                block
                                class="mt-7 mb-3"
                                >Enviar correo</v-btn
                            >
                        </form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { auth  } from '../plugins/firebase'

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            user_exists: true,
            rules: {
                required: value => !!value || 'Ingrese el correo',
                valid: v => this.validateEmail() || 'Ingrese un email valido'
            }
        }
    },
    methods: {
        validateEmail(){
            return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)
        },
        async sendEmail() {
            if(!this.validateEmail()) return
            try {
                await auth.sendPasswordResetEmail(this.email)
                this.$router.push({ name: 'Login' })
            } catch (error) {
                if(error.code === 'auth/user-not-found')
                    this.user_exists = false
            }
        },
    },
}
</script>

<style scoped>
    .container{
        height: 100%;
        background-color: var(--v-primary-base);
    }
</style>